module.exports = __webpack_public_path__ + "static/media/alertAnnouncement.887fab9d.svg";